// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__3OOZN","col":"Table_col__31bdv","fulfillmentStatus":"Table_fulfillmentStatus__McyH-","emailCol":"Table_emailCol__1E3pv"};